import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "sidebar-events-page__loading"
}
const _hoisted_2 = {
  key: 2,
  class: "sidebar-events-page__no-data-item label-m"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventItem = _resolveComponent("EventItem")!
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!

  return (_openBlock(), _createElementBlock("div", {
    class: "episode-events-page",
    ref: "events",
    onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollHandler && _ctx.scrollHandler(...args)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.module.items, (item) => {
      return (_openBlock(), _createBlock(_component_EventItem, {
        key: item.id,
        objects: _ctx.firstObjectType,
        item: item,
        type: "events",
        display: "",
        hideAcknowledge: "",
        defaultAction: _ctx.defaultEventAction,
        iconActions: _ctx.iconActions,
        onAction: (v) => _ctx.actionHandler(item.id, v, item)
      }, null, 8, ["objects", "item", "defaultAction", "iconActions", "onAction"]))
    }), 128)),
    (_ctx.secondModule)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.secondModule.items, (item) => {
          return (_openBlock(), _createBlock(_component_EventItem, {
            key: item.id,
            objects: _ctx.secondObjectType,
            item: item,
            type: "events",
            display: "",
            hideAcknowledge: "",
            defaultAction: _ctx.defaultEventAction,
            iconActions: _ctx.iconActions,
            onAction: (v) => _ctx.actionHandler(item.id, v, item)
          }, null, 8, ["objects", "item", "defaultAction", "iconActions", "onAction"]))
        }), 128))
      : _createCommentVNode("", true),
    (_ctx.module.loading || _ctx.module.appending)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_NLoadingCircle)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.module.items.length && !_ctx.module.loading && !_ctx.secondModule?.items?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('common.no_data', 'f')), 1))
      : _createCommentVNode("", true)
  ], 544))
}